export default "<div class=\"page-content\">\n  <div class=\"page-body\">\n    <router-outlet></router-outlet>\n  </div>\n</div>";